import store from "@/store";
import { i18n } from "@/locales";

store.subscribe((mutation) => {
  if (mutation.type.startsWith('COMPANY')) {
    let languageCode = store.state.company.COMPANY.communications_language.iso_code;
    let countryCode = store.state.company.COMPANY.country.iso_code

    const companyLocale = languageCode.toLowerCase() + '-' + countryCode.toUpperCase();
    if (companyLocale !== i18n.locale) {
        i18n.locale = companyLocale;
    }
  }
});
